import * as Mamba from '@mamba/clients';
import lodash from 'lodash';
const baseURL = process.env.base || ''; //bad
/**
 * @desc 静态资源
 */
export const Static = {
    errImage: 'images/err-image.png',
    auth: 'images/auth.png',
    default_avatar: 'images/default-avatar.png',
    banner_bg: 'images/bg.png',
};
lodash.merge(Static, lodash.mapValues(Static, (val) => {
    if (Mamba.Regulars.url.test(val) ||
        ['base64', '/static/'].some((x) => lodash.includes(val, x))) {
        return val;
    }
    return lodash.join([lodash.trimEnd(baseURL, '/'), lodash.trimStart(val, '/')], '/');
}));
